import React from 'react';
import { ArrowRightIcon, LockKeyholeIcon, ShieldCheckIcon } from 'lucide-react';
interface ActionButtonProps {
  children: React.ReactNode;
  href?: string;
  showTrust?: boolean;
  className?: string;
}
export const checkoutUrl = 'https://protocolo-reencuentro-en-calma.impultienda.ar/checkout';
export function ActionButton({
  children,
  href = checkoutUrl,
  showTrust = false,
  className = ''
}: ActionButtonProps) {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (href !== '#pricing') return;
    event.preventDefault();
    const destination = document.getElementById('pricing');
    if (!destination) return;
    const start = window.scrollY;
    const target = destination.getBoundingClientRect().top + start;
    const duration = 360;
    const startTime = performance.now();
    const step = (time: number) => {
      const progress = Math.min((time - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 4);
      window.scrollTo(0, start + (target - start) * eased);
      if (progress < 1) window.requestAnimationFrame(step);
    };
    window.requestAnimationFrame(step);
  };
  return <div className={className} data-id="element-12" data-mp="2b4aabur97sx0">
      <a href={href} onClick={handleClick} className="group inline-flex w-full items-center justify-center gap-2 rounded-full bg-brand-green px-6 py-4 text-center font-display text-base font-bold text-white shadow-[0_8px_28px_rgba(22,163,74,0.26)] transition-colors duration-150 ease-out hover:bg-brand-light hover:text-brand-ink sm:text-lg" data-id="element-13" data-mp="2g1ag04k6ytnl">
        {children}
        <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-14" data-mp="1xaixacebdqwj" />
      </a>
      {showTrust && <div className="mt-3 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-slate-400" data-id="element-15" data-mp="14mwwfbwh10dd">
          <span className="inline-flex items-center gap-1.5" data-id="element-16" data-mp="19kyd5q6fcnlo">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-brand-light" aria-hidden="true" data-id="element-17" data-mp="19jdi7zg772na" />
            Garantía 14 días
          </span>
          <span className="inline-flex items-center gap-1.5" data-id="element-18" data-mp="wm8sv80a9sgq">
            <LockKeyholeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-19" data-mp="wjmhexa9ust8" />
            Pago seguro
          </span>
          <span data-id="element-20" data-mp="16bij0ibkh127">Mercado Pago</span>
        </div>}
    </div>;
}